import "./scripts/init.js";
import "./components.js";
import { slider } from "./components/slider.js";

//
//
//
//
// Общие скрипты

// Шаги
let stepSlider = [
  ".step-container",
  {
    loop: true,
    resistanceRatio: 0,
    pagination: {
      el: ".step__pagination",
      type: "bullets",
      clickable: true,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    spaceBetween: 20,
    speed: 500,
    slidesPerView: "auto",
  },
];

slider("max-width: 767px", stepSlider);
